var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeicon9Mob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 15.55 14.16 20.74 9 22C3.84 20.74 0 15.55 0 10V4L9 0L18 4V10ZM9 20C12.75 19 16 14.54 16 10.22V5.3L9 2.18L2 5.3V10.22C2 14.54 5.25 19 9 20ZM11.8 10V8.5C11.8 7.1 10.4 6 9 6C7.6 6 6.2 7.1 6.2 8.5V10C5.6 10 5 10.6 5 11.2V14.7C5 15.4 5.6 16 6.2 16H11.7C12.4 16 13 15.4 13 14.8V11.3C13 10.6 12.4 10 11.8 10ZM10.5 10H7.5V8.5C7.5 7.7 8.2 7.2 9 7.2C9.8 7.2 10.5 7.7 10.5 8.5V10Z",
    fill: "#D40033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon9Mob);
export default __webpack_public_path__ + "static/media/homeicon9mob.35d6a0bb200e0521f84178dbf8ba40ff.svg";
export { ForwardRef as ReactComponent };